import { getEmbedVideo } from '../services/vod';
import {
  isReadyLiveStream,
  isPendingLiveStream,
  isScheduledLive,
  getPollStep,
} from '@wix/wix-vod-shared/common';
import { logSharedBi } from '../bi';

class LiveStartHandler {
  timeouts = [];

  constructor(videoItem, channelId, updateVideoItem, onLiveStream) {
    this.videoItem = videoItem;
    this.channelId = channelId;
    this.updateVideoItem = updateVideoItem;
    this.onLiveStream = onLiveStream;
  }

  handleLive() {
    const { videoItem } = this;

    if (isReadyLiveStream(videoItem)) {
      this.onLiveStream();
    } else if (isScheduledLive(videoItem) || isPendingLiveStream(videoItem)) {
      this.pollScheduledVideo();
    }
  }

  handleLiveUnmount() {
    this.timeouts.forEach((timeoutId) => clearTimeout(timeoutId));
  }

  logPollEvent(isError = false, errorMessage = null) {
    const { videoItem } = this;
    let videoType = null;
    if (isPendingLiveStream(videoItem)) {
      videoType = 'live';
    } else if (isScheduledLive(videoItem)) {
      videoType = 'scheduled';
    }

    logSharedBi('widget.poll.request.sent', {
      videoType,
      isError,
      errorMessage,
    });
  }

  pollScheduledVideo() {
    const { videoItem } = this;
    const step = getPollStep(videoItem);
    if (!step) {
      return;
    }

    this.askIfStreamStarted().then((data) => {
      if (data) {
        this.onLiveStream();
        this.updateVideoItem(data);
      } else {
        this.timeouts[videoItem.id] = setTimeout(
          () => this.pollScheduledVideo(),
          step,
        );
      }
    });
  }

  askIfStreamStarted() {
    const { videoItem, channelId } = this;

    return getEmbedVideo({ channelId, videoId: videoItem.id })
      .then((data) => {
        this.logPollEvent();
        return isReadyLiveStream(data) && data;
      })
      .catch((e) => {
        this.logPollEvent(true, e.message);
        return null;
      });
  }
}

export default LiveStartHandler;
